import DateInput from "../../forms/DateInput";
import DateRangeInput from "../../forms/DateRangeInput";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { FILTER_OPERATORS } from "../dialogs/DialogFilterExtended";

/**
 * Date filter cell component
 */
const CompactDateFilterCell = (props) => {
  const { value, onChange, operator, field, type } = props;
  const operators = FILTER_OPERATORS["date"] || [];
  const handleChange = (name, newValue, e) => {
    if (operator === "between" && value?.start && value?.end && (newValue.start === null || newValue.end === null)) {
      //clean value
      newValue = null
    }
    onChange({
      value: newValue,
      operator: newValue ? (operator ? operator : "eq") : "",
      nativeEvent: e ? e.nativeEvent : new Event("change"),
      syntheticEvent: e ? e.syntheticEvent : new Event("change"),
    });
  };

  const handleOperatorChange = (e) => {
    const newOperator = e.target.value.operator;
    const isDate = value instanceof Date;

    const newValue = (isDate && newOperator === "between") || (!isDate && newOperator !== "between") ? null : value;
    onChange({
      value: newValue,
      operator: newOperator,
      nativeEvent: e.nativeEvent,
      syntheticEvent: e.syntheticEvent,
    });
  };

  const operatorValue = (operators && operators.find((x) => x.operator === operator)) || operators[0];

  return <div className="compact-date-filter-cell k-filter-menu-container" >
    <DropDownList data={operators} textField={"text"} value={operatorValue} onChange={handleOperatorChange} />
    {operator === "between" ? (
      <DateRangeInput
        noFormInput={true}
        name={field}
        onChange={handleChange}
        value={value}
        format={"dd.MM.yyyy"}
        calendarSettings={{
          bottomView: "month",
          topView: "year",
          views: 3,
        }}
      />
    ) : (
      <DateInput noFormInput={true} type={type?.replace("input", "") || 'date'} onChange={handleChange} value={value} format={"dd.MM.yyyy"} name={props.field} todayHidden={true} validationHidden={true} />
    )}
  </div>
};



export default CompactDateFilterCell;
